// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ErzeugerListe } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type SucheErzeugerQuery = {
  search?: string;
  filtered?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useSucheErzeuger(): (
  query: SucheErzeugerQuery
) => Promise<ErzeugerListe> {
  const getAPI = useGetApi();
  return useCallback(
    async (query = {}) => (await getAPI()).erzeuger.sucheErzeuger({ ...query }),
    [getAPI]
  );
}
